import api from "../lib/api";

const payloadFor = ({ productId, product_id, color = "", selectedColor = "", size = "", selectedSize = "" }) => ({
  productId: productId || product_id,
  color: selectedColor || color || "",
  size: selectedSize || size || "",
});

export const getWishlist = async () => {
  const { data } = await api.get("/wishlist");
  return data;
};

export const addWishlistItem = async (item) => {
  const { data } = await api.post("/wishlist/add", payloadFor(item));
  return data;
};

export const removeWishlistItem = async (item) => {
  const { data } = await api.delete("/wishlist/remove", { data: payloadFor(item) });
  return data;
};

export const moveWishlistItemToCart = async (item) => {
  const { data } = await api.post("/wishlist/move-to-cart", payloadFor(item));
  return data;
};
